import React, {Component} from 'react';
import Input from '../../../../UI/Input/Input';
import Button from '../../../../UI/Button/Button';
import {SUPER_USER, HSID_DATA, UTC_NAME, SESSION_BASELINEAGENT}  from "../../../../shared/Constants";
import classes from './HealthSafeIdData.css';
import Wrap from '../../../../hoc/Wrap/Wrap';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions/index';
import Message from '../../../../components/Message/Message';
import { checkValidity, isBasicMemberAccount, isPartialRegistration, isAccountDisabled } from '../../../../shared/utility';
import Moment from 'moment';


class HealthSafeIdData extends Component{
    state = {
        hsidDataForm: {
            FirstName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id:'firstName',
                    placeholder: 'first name',
                    maxLength: 41
                },
                value: this.props.member.mdmFirstNm,
                validation: {
                    required: true,
                    minlength: 2,
                    maxlength: 40,
                    specialchar: ['<','"','+',':',';','=','\\','*','&','(',')','#', ',']
                },
                disabled: isAccountDisabled(this.props.member.essoData),
                valid: true,
                touched: false,
                label: "First Name",
                inputType: "OneThirdInlineBlock"
            },
            LastName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id:'lastName',
                    placeholder: 'last name',
                    maxLength: 41
                },
                value: this.props.member.mdmLastNm,
                validation: {
                    required: true,
                    minlength: 2,
                    maxlength: 40,
                    specialchar: ['<','"','+',':',';','=','\\','*','&','(',')','#', ',']
                },
                disabled:  isAccountDisabled(this.props.member.essoData),
                valid: true,
                touched: false,
                label: "Last Name",
                inputType: "OneThirdInlineBlock"
            },
            DOB: {
                elementType: 'input',
                elementConfig: {
                    type: 'date',
                    id:'dob',
                    placeholder: 'mm/dd/yyyy',
                    min: '1900-01-01'
                },
                value: this.props.member.mdmDob,
                validation: {
                    required: true,
                    restrictFuture: true,
                    restrictLowerDate: true
                },
                disabled:  isAccountDisabled(this.props.member.essoData),
                valid: true,
                touched: false,
                label: "DOB",
                inputType: "OneThirdInlineBlock"
            },
            ZipCode: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id:'zipCode',
                    minLength: 5,
                    maxLength: 5,
                    pattern: '[0-9]{1,5}',
                    title:'Zip can only contain numbers'
                },
                value: this.props.member.mdmZip ? this.props.member.mdmZip : "",
                validation: {
                    required: true,
                    minlength: 5,
                    maxlength: 5
                },
                disabled:  isAccountDisabled(this.props.member.essoData),
                valid: true,
                touched: false,
                label: "Zip Code",
                inputType: "OneThirdInlineBlock"
            },
            SubscriberId: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id:'subscriberId',
                    minLength: 2,
                    maxLength: 30,
                    pattern: '[a-zA-Z0-9]{1,30}',
                    title: 'Invalid alpha-numeric characters'
                },
                value: this.props.member.mdmSubscriberId,
                validation: {
                    required: false,
                    minlength: 2,
                    maxlength: 30
                },
                disabled:  isAccountDisabled(this.props.member.essoData),
                valid: true,
                touched: false,
                label: "Subscriber Id",
                inputType: "OneThirdInlineBlock"
            },
            GroupId: {
              elementType: 'input',
              elementConfig: {
                  type: 'text',
                  id:'groupId',
                  maxLength: 30,
                  pattern: '[a-zA-Z0-9]{1,30}',
                  title:'Policy/Group can only contain alpha-numeric characters'
              },
            value: this.props.member.mdmPolicyNbr,
            validation: {
                required: false,
                minlength: 2,
                maxlength: 30
            },
            disabled:  isAccountDisabled(this.props.member.essoData),
            valid: true,
            touched: false,
            label: "Policy/Group #",
            inputType: "OneThirdInlineBlock"
          }
        },
        formHeader: SUPER_USER,
        formMessage: HSID_DATA,
        formIsValid: false,
        error: null,
        message: null,
        updateCacheMsg:null,
        // updateHsidInfoMessage:null,
        // deleteAccountStatus:true
    }

    componentDidMount() {
        this.props.setSuperUserDisplayMessage(null);
    }

    checkResgistrationPortalName(portalName){
        switch(portalName){
            case "BRIOVA":
                return "OSP"
            case "CAREADVISORCONNECT":
                return "Care Advisor Connect Portal"
            case "CAREADVISORCONNECTM":
                return "Care Advisor Connect Mobile"
            case "SIERRAHPNSHL":
                return "HPN / SHL Mobile"
            case "SIERRAHPN":
                return "HPN / SHL Portal"
            default:
                return portalName
        }
    }

    inputChangedHandler =(event, inputIdentifier) => {

        let updatedForm = {...this.state.hsidDataForm};

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = event.target.value;
        let formIsValid = true;
        if(event.target.value) {
            if(updatedFormElement.validation != null) {
                const validation = checkValidity(updatedFormElement.value, updatedFormElement.validation);
                updatedFormElement.valid =  validation.isValid;
                if(validation.isValid) { this.props.setSuperUserDisplayMessage(null); }
                else if (validation.message) { this.props.setSuperUserDisplayMessage({type: "Error", info: {message:validation.message}}); }
            }
        } else  {
            updatedFormElement.valid = false;
            this.props.setSuperUserDisplayMessage(null);
        }
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }

        //console.log("Updated form elements: " , updatedForm);
        this.setState({hsidDataForm: updatedForm, formIsValid: formIsValid});
    }

    resetFormHandler = (event) => {
       //console.log("[Super User] resetHandler" );
       event.preventDefault();
       if(this.props.disableTab === "-1" || (this.props.isOTPVerified || this.props.user.userType === SESSION_BASELINEAGENT)) {
        return;
       }
       this.props.setSuperUserDisplayMessage(null);
       let updatedForm = this.state.hsidDataForm;
       updatedForm['FirstName'].value = this.props.member.mdmFirstNm;
       updatedForm['FirstName'].valid = true;
       updatedForm['LastName'].value = this.props.member.mdmLastNm;
       updatedForm['LastName'].valid = true;
       updatedForm['SubscriberId'].value = this.props.member.mdmSubscriberId;
       updatedForm['SubscriberId'].valid = true;
       updatedForm['GroupId'].value = this.props.member.mdmPolicyNbr;
       updatedForm['GroupId'].valid = true;
       updatedForm['DOB'].value = this.props.member.mdmDob;
       updatedForm['DOB'].valid = true;
       updatedForm['ZipCode'].value = this.props.member.mdmZip;
       updatedForm['ZipCode'].valid = true;
       // let updatedHsidInfoMessage = this.state.updateHsidInfoMessage;
       // updatedHsidInfoMessage = null;

       // this.setState({hsidDataForm: updatedForm, formIsValid: false,updateHsidInfoMessage: null});
        this.setState({hsidDataForm: updatedForm, formIsValid: false});
    }

    updateHSIDDataHandler = (event) =>{
      // console.log("[Super User] updateHSIDDataHandler",this.props.member );
       event.preventDefault();
       if(this.props.disableTab === "-1" || (this.props.isOTPVerified || this.props.user.userType === SESSION_BASELINEAGENT)) {
        return;
       }
       //resetting the updateHSIDINFO Message if any
       // this.setState({updateHsidInfoMessage:null});
       let formData = {};
       let fieldsModified = {};
       let counter = 0;
       let updateMsg = "";
       let actualData = {
            "FirstName": this.props.member.mdmFirstNm,
            "LastName": this.props.member.mdmLastNm,
            "SubscriberId": this.props.member.mdmSubscriberId,
            "GroupId": this.props.member.mdmPolicyNbr,
            "DOB":this.props.member.mdmDob,
            "ZipCode":this.props.member.mdmZip?this.props.member.mdmZip:""
       };
       for(let formElementIdentifier in this.state.hsidDataForm) {
            formData[formElementIdentifier] = this.state.hsidDataForm[formElementIdentifier].value;
            if(this.state.hsidDataForm[formElementIdentifier].value !== actualData[formElementIdentifier] ) {
                fieldsModified[formElementIdentifier] = this.state.hsidDataForm[formElementIdentifier].label;
                ++counter;
            }
       }

       if(counter > 0){
        for(let element in fieldsModified) {
            updateMsg = updateMsg.concat(fieldsModified[element]);
            updateMsg = updateMsg.concat(", ");
       }
       updateMsg = updateMsg.trim();
       updateMsg = updateMsg.slice(0,updateMsg.length-1);
       if(counter > 1) {
            updateMsg = updateMsg.concat(" are updated");
       } else if(updateMsg.length > 0){
            updateMsg = updateMsg.concat(" is updated");
       }

       formData.healthSafeId = this.props.member.healthSafeId;
       formData.termAndConditions = this.props.member.mdmTermAndConditions? this.props.member.mdmTermAndConditions:"";
       formData.requestType = "MDM";
       formData.userName = this.props.member.essoData.userName;
       formData = {
           ...formData,
           addEligibilityPrevInfo: {
            FirstName: this.props.member.mdmFirstNm,
            LastName: this.props.member.mdmLastNm,
            SubscriberId: this.props.member.mdmSubscriberId,
            GroupId: this.props.member.mdmPolicyNbr,
            DOB: this.props.member.mdmDob,
            ZipCode: this.props.member.mdmZip
           }
       }
       this.props.updateHsidInfo(formData,updateMsg);
       }
    }

    render() {

       let formsElementsArray = [];
       for(let key in this.state.hsidDataForm) {
           formsElementsArray.push({
             id: key,
             config: this.state.hsidDataForm[key]
           });
       }

        /* Commented out as this Delete Account section is moving to Account Status Section
        let deleteButton = (
            <div style={{margin: "0 30px 0 30px", paddingRight:"10%"}}>
                <ToggleSwitch
                    id="deleteAccount"
                    labelText="Delete Account"
                    status={!this.props.deleteAccountStatus}
                    onText="Active"
                    offText="Deleted"
                    disabled={this.props.deleteAccountStatus}
                    clicked={this.deleteAccountHandler}
                />
        </div>);*/

        let saveButtons = this.props.deleteAccountStatus?null:(
            <div style={{display:"flex", justifyContent:"center", margin: "10px 60px 10px 0"}}>
                <Button id="cancel" btnType="Cancel" clicked={this.resetFormHandler} disabled={ isAccountDisabled(this.props.member.essoData)}>Cancel</Button>
                <Button id="save" btnType="Search" disabled={!this.state.formIsValid ||  isAccountDisabled(this.props.member.essoData)}>Save</Button>
            </div>
        );

        let createDate = this.props.member.createTimestamp ? Moment(this.props.member.createTimestamp).format('YYYY-MM-DD')+UTC_NAME : "";

        const HsidDataForm = (
            
            <form onSubmit={this.updateHSIDDataHandler}>
<div>
                    {formsElementsArray.map(formElement => {
                        return (
                            <Input
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={formElement.config.value}
                                disabled={this.props.deleteAccountStatus || formElement.config.disabled}
                                invalid={!formElement.config.valid}
                                shouldValidate={formElement.config.validation}
                                touched={formElement.config.touched}
                                label={formElement.config.label}
                                changed={(event) => this.inputChangedHandler(event, formElement.id)}
                                inputType={formElement.config.inputType}
                                tabIndex={this.props.disableTab != undefined ? this.props.disableTab : (this.props.isOTPVerified || this.props.user.userType === SESSION_BASELINEAGENT ? "-1" : "0")}
                            />
                        )}
                    )}
                    </div>
                    <div style={{display:"flex", flexFlow:"row"}}>
                    <div className={classes.RowSplit}>
                        <label className={classes.RowLabel}>HSID Created Date</label>
                        <span className={classes.Bottom}>{createDate}</span>
                    </div>
                    <div className={classes.RowSplit2}>
                        <label className={classes.RowLabel}>HSID Registration Portal</label>
                        <span className={classes.Bottom}>{this.props.member.mbrRgstPrtlShrtNm? this.checkResgistrationPortalName(this.props.member.mbrRgstPrtlShrtNm):"NA"}</span>
                    </div>
                </div>
                {saveButtons}
             </form>
            //  </div>
         );

        let updateCacheMessage = null;
        if(this.props.updateCacheMessage) {
            updateCacheMessage = <Message msgType={this.props.updateCacheMessage.type} info={this.props.updateCacheMsg} />;
        }
        let updateHsidInfoMsg = null;
        if(this.props.updateHsidInfoMessage) {
            updateHsidInfoMsg = <Message msgType={this.props.updateHsidInfoMessage.type} info={this.props.updateHsidInfoMessage} />;
        }

        const superUserDispMsg = this.props.superUserDispMsg!==null? <div className={classes.RowMessage}><Message msgType={this.props.superUserDispMsg.type} info={this.props.superUserDispMsg.info} /></div>: null;
        return (
            <Wrap>
                <div className={classes.SuperUser}>
                    {/*<h4 className={classes.FormTitle}>{this.state.formHeader}</h4>*/}
                    <p className={classes.FormTitle}> {this.state.formMessage}</p>
                </div>
                <div style={{paddingLeft:"20px"}}>
                    {superUserDispMsg}
                    {updateCacheMessage}
                    {updateHsidInfoMsg}
                </div>
                <div className={classes.DisableHealthSafeIdLayerWrapper}>
                    { (this.props.isOTPVerified ||
                    this.props.user.userType === SESSION_BASELINEAGENT)? <div className={classes.DisableHealthSafeIdLayer}></div> : null}
                    {!isBasicMemberAccount(this.props.idType) && !isPartialRegistration(this.props.idType) ? HsidDataForm : null}
                </div>
            </Wrap>
        );
    }
}

const mapStateToProps = state => {
    return {
        member: state.member.member,
        superUserDispMsg: state.addAccount.superUserMessage,
        deleteAccountStatus: state.member.deleteAccountStatus,
        updateCacheMsg: state.member.updateCacheMsg,
        updateHsidInfoMessage: state.member.updateHsidInfoMsg,
        user: state.usr.user,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        deleteAccount: (uuid) => dispatch(actions.deleteAccount(uuid)),
        updateHsidInfo:(memberInfo,updateMsg) => dispatch(actions.updateHsidInfo(memberInfo,updateMsg)),
        setSuperUserDisplayMessage: (message) => dispatch(actions.setSuperUserDisplayMessage(message)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HealthSafeIdData);
